import car from './car.svg';
import grey_car from './grey_car.svg';
import backed_by_iag from './backed_by_iag.svg';
import flybuys_logo from './flybuys_logo.svg';
import ten_percent_discount from './ten_percent_discount.svg';
import fifteen_percent_discount from './fifteen_percent_discount.svg';
import visa from './visa.svg';
import mastercard from './mastercard.svg';
import roadside_assist from './roadside_assist.svg';
import under25s_steering from './under25s_steering.svg';
import windscreen_broken from './windscreen_broken.svg';
import car_crash from './car_crash.svg';
import card_payment from './card_payment.svg';
import hail_damaged_car from './hail_damaged_car.svg';
import phone_angled from './phone_angled.svg';
import building from './building_red_simple.svg';
import homeForRent from './home_for_rent 2.svg';
import colesInsurance from './Coles_Insurance_logo-horizonal-red-RGB.svg';
import callSymbol from './call_symbol.svg';
import flybuysCard from './flybuys_card.svg';
import exchange from './exchange_red.svg';
import building_roof_flying from './building_roof_flying.svg';
import camera from './camera.svg';
import washingMachineSmoke from './washing_machine_smoke.svg';
import spilledWine from './spilled_wine.svg';
import airconSmoke from './aircon_smoke.svg';
import rentDefaultCover from './Fair_RGB_2.svg';
import lossOfRent from './rent_default_cover.svg';
import timer from './timer.svg';
import carHomeCombined from './car-home-combined-01.svg';
import chromeLogo from './chrome-logo.png';
import firefoxLogo from './firefox-logo.png';
import edgeLogo from './edge-logo.png';
import safariLogo from './safari-logo.png';
import alertSymbol from './alert_symbol.svg';
import canstar_2021 from './canstar-2021.png';
import canstar_2021_22 from './canstar-2021-2022-award-143x70.svg';
import financial_awards_2021 from './financial-awards-2021.png';
import cupboard from './cupboard.png';

export const ICONS = {
  DEFAULT: {
    UNIFIED: carHomeCombined,
    MOTOR: car,
    HOME: building,
    LANDLORD: homeForRent,
  },
  LOGO: {
    COLES_INSURANCE: colesInsurance,
    BACKED_BY_IAG: backed_by_iag,
    FLYBUYS: flybuys_logo,
    TEN_PERCENT_DISCOUNT: ten_percent_discount,
    FIFTEEN_PERCENT_DISCOUNT: fifteen_percent_discount,
    CANSTAR_2021: canstar_2021,
    CANSTAR_2021_22: canstar_2021_22,
    FINANCIAL_AWARDS_2021: financial_awards_2021,
  },
  BROWSERS: {
    CHROME: chromeLogo,
    FIREFOX: firefoxLogo,
    EDGE: edgeLogo,
    SAFARI: safariLogo,
  },
  CARD: {
    VISA: visa,
    MASTERCARD: mastercard,
    FLYBUYS: flybuysCard,
  },
  OPTIONAL_EXTRA: {
    MOTOR: {
      HIRE_CAR: grey_car,
      ROADSIDE_ASSIST: roadside_assist,
      UNDER_25: under25s_steering,
      WINDSCREEN: windscreen_broken,
    },
    HOME: {
      FUSION_BUILDING: airconSmoke,
      FUSION_CONTENTS: washingMachineSmoke,
      ACCIDENTAL_DAMAGE: spilledWine,
      PORTABLE_CONTENTS: camera,
    },
    LANDLORD: {
      FUSION_BUILDING: airconSmoke,
      FUSION_CONTENTS: washingMachineSmoke,
      LOSS_OF_RENT: lossOfRent,
      RENT_DEFAULT: rentDefaultCover,
      TENANT_DAMAGE: cupboard,
    },
  },
  ERROR: {
    REFERRAL: phone_angled,
    PAYMENT: {
      CARD: card_payment,
    },
    MOTOR: {
      API_ERROR: roadside_assist,
      DECLINED: car_crash,
      EMBARGO: car_crash,
      UNKNOWN: hail_damaged_car,
    },
    HOME: {
      API_ERROR: building,
      DECLINED: building,
      EMBARGO: building,
      UNKNOWN: building_roof_flying,
    },
    LANDLORD: {
      API_ERROR: homeForRent,
      DECLINED: homeForRent,
      EMBARGO: homeForRent,
      UNKNOWN: building_roof_flying,
    },
    MAINTENANCE: timer,
    NOTFOUND: alertSymbol,
  },
  CORE: {
    PHONE: callSymbol,
    EXCHANGE: exchange,
  },
};

export default ICONS;
